var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2 9c0 3.48-3.223 6.3-7.2 6.3-1.342 0-2.6-.322-3.675-.881L1.8 15.3l1.205-2.81C2.244 11.49 1.8 10.29 1.8 9c0-3.48 3.224-6.3 7.2-6.3s7.2 2.82 7.2 6.3Zm-9.9-.9H4.5v1.8h1.8V8.1Zm7.2 0h-1.8v1.8h1.8V8.1Zm-5.4 0h1.8v1.8H8.1V8.1Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.3971eca688f009c222068369619112f8.svg";
export { ForwardRef as ReactComponent };